import { Language } from '^/types';

export default {
  members: {
    [Language.KO_KR]: '멤버',
    [Language.EN_US]: 'Members',
  },
  name: {
    [Language.KO_KR]: '이름',
    [Language.EN_US]: 'Name',
  },
  organization: {
    [Language.KO_KR]: '조직',
    [Language.EN_US]: 'Organization',
  },
  role: {
    [Language.KO_KR]: '역할',
    [Language.EN_US]: 'Role',
  },
  team: {
    [Language.KO_KR]: '조직',
    [Language.EN_US]: 'Team',
  },
  authority: {
    [Language.KO_KR]: '권한',
    [Language.EN_US]: 'Authority',
  },
  featureToggle: {
    ess: {
      [Language.KO_KR]: '안전관리',
      [Language.EN_US]: 'Site Logistics',
    },
  },
  delete: {
    [Language.KO_KR]: '삭제',
    [Language.EN_US]: 'Delete',
  },
  action: {
    [Language.KO_KR]: '조치',
    [Language.EN_US]: 'Action',
  },
  noResultsFound: {
    [Language.KO_KR]: '협력자를 찾을 수 없습니다',
    [Language.EN_US]: 'No collaborators found for',
  },
  noResultsFoundSubTitle: {
    [Language.KO_KR]: '다른 검색을 시도하거나 새로운 협력자를 초대하세요.',
    [Language.EN_US]: 'Try a different search or invite a new collaborator.',
  },
};
